<template>
    <g class="x-axis label" :transform="`translate(${translateOffsetX}, ${translateOffsetY})`">
        <g v-for="(point, index) in points" :key="index"
            class="x-axis--tick"
            :transform="`translate(${point.x}, ${tickPadding}) rotate(${labelRotate})`"
        >
            <text
                class="x-axis--label-text"
                :style="labelStyle"
                :font-size="`${tickSize}rem`"
                :title="point.label"
            >
                <slot name="x-axis" :item="{ ...point, index }"></slot>
            </text>
        </g>
    </g>
</template>

<script>
export default {
    props: [
        'labelRotate',
        'boundary',
        'tickSize',
        'tickPadding',
        'labelColor',
        'points'
    ],
    computed: {
        translateOffsetX () {
            return this.labelRotate >= 0 ? this.boundary.minX : this.boundary.minX - 5
        },
        translateOffsetY () {
            return this.labelRotate >= 0 ? this.boundary.maxY + this.tickPadding : this.boundary.maxY + this.tickPadding + 10
        },
        labelStyle () {
            return {
                'text-anchor': 'middle',
                fill: this.labelColor
            }
        }
    }
}
</script>

<style lang="scss" scoped>
text {
    user-select: none;
}
</style>
